import { render } from "./LoadingDots.vue?vue&type=template&id=33e4862c&scoped=true"
import script from "./LoadingDots.vue?vue&type=script&lang=js"
export * from "./LoadingDots.vue?vue&type=script&lang=js"

import "./LoadingDots.vue?vue&type=style&index=0&id=33e4862c&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-33e4862c"]])

export default __exports__